import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Loader } from '../common/loader/loader'
import { ErrorPage } from '../error/SignupErrorPage'
import { ResetPassword } from './resetPassword'

export function VerifyPasswordLink(props) {
    const [isLoading, setLoading] = useState({ showLoader: true, error: false })

    useEffect(() => {
        const email = props.match.params.email
        const token = props.match.params.verificationId
        axios
            .get(
                process.env.REACT_APP_AUTH_SIGNUP_VERIFICATION_URL +
                    `/${email}/${token}` || `/verification/${email}/${token}`
            )
            .then(success => {
                setLoading({ showLoader: false, error: false })
            })
            .catch(err => {
                setLoading({ showLoader: false, error: true })
            })
        setLoading({ showLoader: true, error: false })
    }, [])

    return isLoading.showLoader ? (
        <Loader.PageLoader
            show={true}
            loadingText={'Loading...'}
            extraMsg={' Please do not refresh page.'}
        />
    ) : isLoading.error ? (
        <ErrorPage {...props} fromPasswordReset={true} />
    ) : (
        <ResetPassword {...props} />
    )
}
